import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

/**
 * Wordmark recreation of the MANOPIRTIS.LT logo:
 * fine hairline above and below the wordmark + tiny tagline.
 */
export default function Brand({ light = false, size = "md" }) {
  const { content } = useContent();
  const site = content.site;
  const color = light ? "#f9f8f6" : "#1a1a1a";
  const sub = light ? "rgba(249,248,246,0.55)" : "rgba(26,26,26,0.5)";
  const wordSize =
    size === "lg"
      ? "text-2xl md:text-[28px]"
      : size === "sm"
      ? "text-[15px]"
      : "text-lg md:text-xl";
  const tickW = size === "lg" ? "w-12" : size === "sm" ? "w-6" : "w-8";

  return (
    <Link
      to="/"
      data-testid="brand-link"
      className="inline-flex flex-col items-center select-none"
      style={{ color }}
    >
      <span
        className={`block h-px ${tickW}`}
        style={{ backgroundColor: color }}
      />
      <span
        className={`font-light tracking-[0.32em] ${wordSize} mt-[6px] mb-[6px] uppercase`}
        style={{ fontFamily: "Manrope, sans-serif", color }}
      >
        {site.brand}
      </span>
      <span
        className={`block h-px ${tickW}`}
        style={{ backgroundColor: color }}
      />
      <span
        className="mt-2 text-[9px] tracking-[0.28em] uppercase"
        style={{ color: sub, fontFamily: "Manrope, sans-serif" }}
      >
        {site.brandTagline}
      </span>
    </Link>
  );
}
